<div class="wnl-header">
  @if(patient().isObstetric()) {
  <p>
    WNL: Voiding without difficulty, Urine straw color, no bladder distention noted. Continent with
    bladder control. Lochia appropriate for post-partem day if applicable.
  </p>
  <mat-checkbox [checked]="wnlManagerOB.allWNL" [indeterminate]="wnlManagerOB.someWNL()"
    (change)="wnlManagerOB.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
  } @else {
  <p>
    WNL: Voiding without difficulty, Urine straw color, no bladder distention noted. Continent with
    bladder control.
  </p>
  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
  }
</div>

<div [formGroup]="formGroup()" class="form-container">
  @if (patient().isObstetric()) {
  <assessment-row title="Urine Characteristics">
    <emr-checkbox-group [hasWNL]="true" [control]="formGroup().controls.urineCharacteristics"
      [options]="urineCharacteristicsOptions" [default]="urineCharacteristicsDefault" wnlLabel="WNL"
      [(wnl)]="this.wnlManagerOB.controlColl['urineCharacteristics'].wnl" (wnlChange)="wnlManagerOB.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Urine Color">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.urineColor" [options]="urineColorOptions"
      [default]="urineColorDefault" [(wnl)]="wnlManagerOB.controlColl['urineColor'].wnl"
      (wnlChange)="wnlManagerOB.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Urinary Pattern">
    <emr-checkbox-group [hasWNL]="true" [control]="formGroup().controls.urinaryPattern"
      [options]="urinaryPatternOptions" [default]="urinaryPatternDefault" wnlLabel="WNL"
      [(wnl)]="wnlManagerOB.controlColl['urinaryPattern'].wnl" (wnlChange)="wnlManagerOB.updateAllWNL()" />
  </assessment-row>

  <h2>Foley</h2>
  <assessment-row title="Justification">
    <emr-input type="text" [hasWNL]="false" width="50%" [control]="formGroup().controls.foleyJustification" />
  </assessment-row>

  <assessment-row title="Securement">
    <emr-input type="text" [hasWNL]="false" width="50%" [control]="formGroup().controls.foleySecurement" />
  </assessment-row>

  <assessment-row title="Abnormal Lochia">
    <emr-checkbox [control]="formGroup().controls.hasAbnormalLochia" label="Yes"></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasAbnormalLochia.value){
  <assessment-row title="Inappropriate Color?">
    <emr-checkbox [control]="formGroup().controls.abnormalLochiaHasInappropriateColor" label=""></emr-checkbox>
  </assessment-row>

  <assessment-row title="Heavy Bleeding?">
    <emr-checkbox [control]="formGroup().controls.abnormalLochiaHasHeavyBleeding" label=""></emr-checkbox>
  </assessment-row>

  <assessment-row title="Foul Odor?">
    <emr-checkbox [control]="formGroup().controls.abnormalLochiaHasFoulOdor" label=""></emr-checkbox>
  </assessment-row>

  <assessment-row title="Other">
    <emr-input type="text" [control]="formGroup().controls.abnormalLochiaOther"></emr-input>
  </assessment-row>
  }

  <assessment-row title="Abnormal Uterine Assessment">
    <emr-checkbox [control]="formGroup().controls.hasAbnormalUterine" label="Yes"></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasAbnormalUterine.value) {
  <assessment-row title="Fundal Location">
    <emr-input type="text" [control]="formGroup().controls.abnormalUterineFundalLocation"></emr-input>
  </assessment-row>
  <assessment-row title="Fundal Feel">
    <emr-input type="text" [control]="formGroup().controls.abnormalUterineFundalFeel"></emr-input>
  </assessment-row>
  <assessment-row title="Contractions Present?">
    <emr-checkbox [control]="formGroup().controls.areContractionsPresent" label=""></emr-checkbox>
  </assessment-row>
  @if (formGroup().controls.areContractionsPresent.value){
  <div>
    <p>Contraction Strength</p>
    <emr-input type="text" [control]="formGroup().controls.contractionsStrength"></emr-input>
    <p>Contraction Duration</p>
    <emr-input type="text" [control]="formGroup().controls.contractionsDuration"></emr-input>
    <p>Contraction Frequency</p>
    <emr-input type="text" [control]="formGroup().controls.contractionsFrequency"></emr-input>
  </div>
  }
  <assessment-row title="Fetal Heart Tones Present?">
    <emr-checkbox [control]="formGroup().controls.hasFetalHeartTones" label=""></emr-checkbox>
  </assessment-row>
  @if (formGroup().controls.hasFetalHeartTones.value) {
  <div>
    <p>Accelerations Noted</p>
    <emr-input type="text" [control]="formGroup().controls.fetalHeartTonesAccelerationsNoted"></emr-input>
    <p>Decelerations Noted</p>
    <emr-input type="text" [control]="formGroup().controls.fetalHeartTonesDecelerationsNoted"></emr-input>
    <p>FHT Variability</p>
    <emr-input type="text" [control]="formGroup().controls.fetalHeartTonesVariability"></emr-input>
  </div>
  }

  <assessment-row title="Abnormal Vaginal Assessment">
    <emr-checkbox [control]="formGroup().controls.hasAbnormalVaginalAssessment" label=""></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.hasAbnormalVaginalAssessment.value) {
  <p>Episiotomy</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalEpisiotomy"></emr-input>
  <p>Tear</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalTear"></emr-input>
  <p>Dilaton</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalDilation"></emr-input>
  <p>Station</p>
  <emr-input type="text" [control]="formGroup().controls.abnormalVaginalStation"></emr-input>
  }
  }

  } @else {

  <assessment-row title="Urine Characteristics">
    <emr-checkbox-group [hasWNL]="true" [control]="formGroup().controls.urineCharacteristics"
      [options]="urineCharacteristicsOptions" [default]="urineCharacteristicsDefault" wnlLabel="WNL"
      [(wnl)]="this.wnlManager.controlColl['urineCharacteristics'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Urine Color">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.urineColor" [options]="urineColorOptions"
      [default]="urineColorDefault" [(wnl)]="wnlManager.controlColl['urineColor'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Urinary Pattern">
    <emr-checkbox-group [hasWNL]="true" [control]="formGroup().controls.urinaryPattern"
      [options]="urinaryPatternOptions" [default]="urinaryPatternDefault" wnlLabel="WNL"
      [(wnl)]="wnlManager.controlColl['urinaryPattern'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <h2>Foley</h2>
  <assessment-row title="Justification">
    <emr-input type="text" [hasWNL]="false" width="50%" [control]="formGroup().controls.foleyJustification" />
  </assessment-row>

  <assessment-row title="Securement">
    <emr-input type="text" [hasWNL]="false" width="50%" [control]="formGroup().controls.foleySecurement" />
  </assessment-row>
  }
</div>